import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition';

import { CASF_COHORTS } from '../experiment-config';

import { useExperimentEnrollment } from './useExperimentEnrollment';

export const useQuickSummaryABExperiment = () => {
	const { edition } = useSessionData();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { cohort } = useExperimentEnrollment('confluence_quick_summary');

	try {
		const isEligible =
			(edition === ConfluenceEdition.FREE || edition === ConfluenceEdition.STANDARD) &&
			fg('confluence_quick_summary_fg_ab');

		const isQualified =
			isEligible && (cohort === CASF_COHORTS.CONTROL || cohort === CASF_COHORTS.TREATMENT);
		const isVariation = cohort === CASF_COHORTS.TREATMENT;

		return {
			isQualified,
			isVariation,
		};
	} catch (error) {
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'error',
				actionSubject: 'useQuickSummaryExperiment',
				source: 'useQuickSummaryExperimentHook',
				attributes: {
					error: error.message,
					edition,
				},
			},
		}).fire();

		return error;
	}
};
